<template>
  <div class="empty">
    <Icon type="empty" />
    <p :style="textStyle">{{ $t('com_table_no_data') }}</p>
  </div>
</template>
<script>
export default {
  props: {
    textStyle: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="less" scoped>
.empty {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #ccc;
  flex-direction: column;
  font-size: 14px;
  font-style: normal;

  p {
    width: 100%;
  }

  svg {
    width: 64px;
  }
}
</style>
